<template>
  <div class="ComfirmOrder">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">采购订单</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>发货登记</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="change_inform">
      <div class="title">PO单信息</div>
      <el-table :data="orderList" class="table_wrap1" border>
        <el-table-column prop="OrderNumber" label="PO单编号"></el-table-column>
        <el-table-column prop="MaterialCount" label="物资种类"></el-table-column>
        <el-table-column prop="ActualCount" label="物资数量"></el-table-column>
        <el-table-column prop="SumFee" label="订单金额"></el-table-column>
      </el-table>
      <div class="title">货物清单</div>
      <div style="float: right">
        <img src="@/assets/img/btn_add.png" alt @click="add" />
        <img src="@/assets/img/btn_delete.png" alt @click="del" />
      </div>
      <el-table :data="invoiceList" class="table_wrap1" border @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="LogisticsCompany" label="物流公司">
          <template slot-scope="scope">
            <el-input placeholder="请输入内容" v-model="scope.row.LogisticsCompany"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="ExpressNumber" label="物流单号">
          <template slot-scope="scope">
            <el-input placeholder="请输入内容" v-model="scope.row.ExpressNumber"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="InvoiceDate" label="发货日期">
          <template slot-scope="scope">
            <el-date-picker v-model="scope.row.InvoiceDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"> </el-date-picker> </template
        ></el-table-column>
        <el-table-column prop="File" label="发货单扫描件（PDF）">
          <template slot-scope="scope">
            <el-upload
              action="#"
              :limit="1"
              :before-remove="removeConfirm"
              :before-upload="beforeUpload"
              :on-remove="handleRemove"
              :on-change="fileChange"
              :on-exceed="exceedFile"
              :on-success="handleSuccess"
              :on-error="handleError"
              :auto-upload="true"
              :file-list="scope.row.fileList"
              :data="{ id: scope.$index }"
              :http-request="uploadTechnicalFile"
              accept=".pdf"
              ref="uploader"
            >
              <el-button size="mini" type="primary" plain>点击上传</el-button>
            </el-upload>
          </template>
        </el-table-column>
        <el-table-column prop="Contactor" label="联系人">
          <template slot-scope="scope">
            <el-input placeholder="请输入内容" v-model="scope.row.Contactor"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="Mobile" label="联系电话">
          <template slot-scope="scope">
            <el-input placeholder="请输入内容" v-model="scope.row.Mobile"></el-input>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注">
          <template slot-scope="scope">
            <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="scope.row.Remark" style="width: 90%"> </el-input>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="btn_wrap changeInform_btn_wrap">
      <span class="btn_1" @click="fnGoBack()">返回</span>
      <span class="btn_1" @click="fnSave()">提交</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Query: {
        OrderNumber: '',
        CreateDate: ''
      },
      invoiceList: [
        {
          LogisticsCompany: '',
          ExpressNumber: '',
          InvoiceDate: '',
          Contactor: '',
          Mobile: '',
          Remark: '',
          id: Math.random(),
          fileList: []
        }
      ],
      orderId: this.$route.query.orderId,
      orderList: [],
      selectList: []
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let config = {
        params: {
          Query: JSON.stringify(this.Query)
        }
      }
      this.getRequest('/Order/GetOrderList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            res.data.AcceptanceList.forEach((element) => {
              if (this.orderId.includes(element.OrderId)) {
                console.log(element.OrderId)
                this.orderList.push(element)
              }
            })
            console.log(this.orderList)
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    fnGoBack() {
      window.close()
    },
    handleSelectionChange(val) {
      this.selectList = val
    },
    add() {
      this.invoiceList.push({
        LogisticsCompany: '',
        ExpressNumber: '',
        InvoiceDate: '',
        Contactor: '',
        Mobile: '',
        Remark: '',
        id: Math.random(),
        fileList: []
      })
    },
    del() {
      this.selectList.forEach((m) => {
        this.invoiceList = this.invoiceList.filter((item) => {
          return item.id != m.id
        })
      })
    },
    uploadTechnicalFile(params) {
      console.log(params)
      let file = params.file
      var data = new window.FormData()
      let loginToken = window.localStorage.getItem('loginToken')
      data.append('file', params.file)
      data.append('loginToken', loginToken)
      this.uploadFileRequest('/Common/UploadFile', data).then((res) => {
        if (res.data.errcode == 0) {
          var obj = [
            {
              fileId: res.data.FileList[0].id,
              name: res.data.FileList[0].fileName,
              status: 'success'
            }
          ]
          this.invoiceList[params.data.id].fileList = obj
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    exceedFile(files, fileList) {
      this.$message({
        showClose: true,
        message: `最多上传1个文件`,
        type: 'warning'
      })
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {},
    // 点击x时执行的钩子函数
    removeConfirm(file, fileList) {
      if (file.status == 'success') {
        return this.$confirm(`确定删除 ${file.name}？`)
      }
    },
    handleRemove(file, fileList) {
      if (file.hasOwnProperty('fileId')) {
        this.postRequest('/Common/DeleteAttachmentByFileId', {
          fileId: file.fileId
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.invoiceList.forEach((m) => {
              m.fileList = m.fileList.filter((item) => {
                return item.uid != file.uid
              })
            })
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if (response.errcode == 0) {
        this.fileList = fileList
        // this.fileIds.push(response.fileId);
        this.$notify.success({
          title: '上传结果',
          message: `${file.name}上传成功`,
          position: 'bottom-right'
        })
      } else {
        this.$notify.error({
          title: '上传结果',
          message: `${file.name}上传失败:${response.errmsg}`,
          position: 'bottom-right'
        })
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: '上传结果',
        message: `${file.fileName}上传失败:{err}`,
        position: 'bottom-right'
      })
    },
    handleUpload(raw) {},
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = testmsg === 'pdf' || testmsg === 'PDF'
      if (!extension) {
        this.$message({
          message: '上传文件只能是pdf格式!',
          type: 'warning'
        })
      }
      return extension
    },
    fnSave() {
      let flag = true
      if (this.invoiceList.length <= 0) {
        flag = false
        this.$message({
          message: '请先填写发货单信息在提交',
          type: 'warning'
        })
        return
      }
      for (var i = 0; i < this.invoiceList.length; i++) {
        var item = this.invoiceList[i]
        if (item.LogisticsCompany == '' && flag == true) {
          this.$message.error('请填写第' + (i + 1) + '列的快递公司')
          flag = false
        }
        if (item.ExpressNumber == '' && flag == true) {
          this.$message.error('请填写第' + (i + 1) + '列快递单号')
          flag = false
        }
        if (item.fileList.length == 0 && flag == true) {
          this.$message.error('请上传第' + (i + 1) + '列发货单扫描件')
          flag = false
        }
        if (item.InvoiceDate == '' && flag == true) {
          this.$message.error('请填写第' + (i + 1) + '列发货日期')
          flag = false
        }
        if (item.Contactor == '' && flag == true) {
          this.$message.error('请填写第' + (i + 1) + '列联系人')
          flag = false
        }
        if (item.Mobile == '' && flag == true) {
          this.$message.error('请填写第' + (i + 1) + '列联系电话')
          flag = false
        }
      }
      if (flag == true) {
        let invoiceList = JSON.stringify(this.invoiceList)
        this.postRequest('/Order/OrderInvoice', {
          orderId: this.orderId,
          invoiceList: invoiceList
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.$message.success('提交成功')
            localStorage.setItem('orderList', Math.random())
            setTimeout(() => {
              window.close()
            }, 1000)
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ComfirmOrder {
  .right_content {
    margin: 0 10px;
    height: 93%;
    background: #fff;
  }

  .title2 {
    font-size: 18px;
    border-bottom: 1px solid #95c7f0;
    padding-bottom: 7px;
    margin: 7px;
  }

  //重写el-table样式
  .el_table {
    width: 98%;
    margin: 0 auto;
    border: none;
  }

  .el_table ::v-deep .el-table__header {
    th {
      background: #d8eafa;
      text-align: center;
      border-bottom: 2px solid #e4e4e4;
      color: #333;
    }
  }

  .el_table ::v-deep .el-table__body-wrapper {
    tr {
      background-color: #e6f6fb;
    }

    td {
      text-align: center;
      border-bottom: 1px solid #e4e4e4;
      border-right: none;
      background-color: #fff;
    }
  }

  .change_inform ::v-deep.icon_tips2 {
    vertical-align: middle !important;
  }

  .changeInform_btn_wrap {
    width: 366px;
    margin: 40px auto 0;

    .btn_1 {
      background: #f60;
      border: 1px solid #f60;
      color: #fff;
      border-radius: 8px;
    }

    .btn_1:nth-of-type(1) {
      margin-right: 30px;
    }
  }

  .title2_span {
    margin-left: auto;
    color: #0660a2;
    font-weight: bold;
    font-size: 13px;
  }

  .btn {
    margin-left: 50px;
    color: #fff;
    border: 1px solid #6a96bc;
    border-radius: 5px;
    padding: 2px 18px;
    font-size: 15px;
    background: #2db7f5;
  }

  .form_wrap .btn_wrap {
    position: absolute;
    right: 2px;
    top: 42px;
    z-index: 100;
  }

  .change_inform {
    padding-top: 15px;

    .title {
      height: 34px !important;
      line-height: 40px !important;
      border-bottom: 1px solid #95c7f0 !important;
      margin-bottom: 13px;
      // padding-top: 15px !important;
    }

    ::v-deep .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background-color: #95c7f0;
    }

    ::v-deep .table_wrap1 {
      table {
        margin: 0;

        td,
        tr,
        th {
          border-color: #95c7f0;
        }

        th {
          border-top: 1px solid #95c7f0;
          border-right: 1px solid #95c7f0;
          border-color: #95c7f0;
          background-color: #d8eafa;

          &:first-child {
            border-left: 1px solid #95c7f0;
          }
        }

        td {
          border-bottom: none;

          &:first-child {
            border-left: 1px solid #95c7f0;
          }
        }
      }

      .el-table__body-wrapper {
        border-bottom: 1px solid #95c7f0;
      }
    }
  }
}
</style>